// React 16.8.6 ne fournit pas `useId` (apparu en React 18).
// Plusieurs composants @nbc-design/* upgrade en juin 2026 s'appuient sur
// `React.useId()`. Ce polyfill produit un identifiant stable par composant
// avec le format ":r<n>:" pour rester compatible avec les conventions React 18.
//
// `require` nous donne une référence mutable au module React : avec
// `esModuleInterop`, `import * as React` est compilé via `__importStar` qui
// retourne une copie figée du namespace, donc la mutation ne se propage pas
// aux autres consommateurs. Le cast typé évite l'erreur TS2347 sur
// `useRef<T>()` qu'on aurait sur un module typé `any`.

type ReactModule = typeof import('react') & { useId?: () => string };

// eslint-disable-next-line @typescript-eslint/no-var-requires
const reactModule = require('react') as ReactModule;

if (typeof reactModule.useId !== 'function') {
  let counter = 0;

  reactModule.useId = function useIdPolyfill(): string {
    const idRef = reactModule.useRef<string | null>(null);
    if (idRef.current === null) {
      counter += 1;
      idRef.current = `:r${counter.toString(36)}:`;
    }
    return idRef.current;
  };
}

export {};
